import auth from "./auth";
import cms from "./cms";

export default {
    ...auth,
    ...cms,
};
